export function LoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="p-10 text-center text-sm text-text-tertiary">
      <p>Die Daten konnten nicht geladen werden (Verbindungsproblem).</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-3 text-accent hover:underline"
      >
        Erneut versuchen
      </button>
    </div>
  );
}
